import { Trans } from "react-i18next"

const ChallengeClosed = ({ ownerChallenge }) => {
  return (
    <Trans
      i18nKey="notifications.challengeClosed"
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
      components={{ b: <b /> }}
    />
  )
}

export default ChallengeClosed
